<template>
  <b-card class="serviceVoucher__card">
    <b-card-header>
      <b-container>
        <b-row align-v="center" class="py-3">
          <b-col cols="2">
            <b-btn disabled size="sm" variant="outline-primary" v-if="shouldShowIndex">
              {{index}}
            </b-btn>
          </b-col>
          <b-col cols="8">
            <div class="h6 text-center my-0">
              {{ booking.pick_up_date | moment("D&nbsp;MMM&nbsp;YY HH:mm") }}
            </div>
          </b-col>
          <b-col cols="2" class="text-right">
            <div class="serviceVoucher__card__handle" v-if="draggable">
              <i class="fa fa-arrows-alt fa-lg"></i>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-card-header>
    <div>
      <div class="bg-light py-1">
        <b-container>
          <b-row>
            <b-col cols="5" class="text-right">
              <small>{{getLocationNameById(booking.pick_up_location)}}</small>
            </b-col>
            <b-col cols="2" class="text-center">
              <div>
                <i class="fa fa-long-arrow-right text-primary"></i>
              </div>
            </b-col>
            <b-col cols="5">
              <small>{{getLocationNameById(booking.drop_off_location)}}</small>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-container>
        <b-row class="my-2">
          <b-col cols="6" class="text-center">
            <div>Client</div>
            <p class="h6">
              {{booking.full_name}}
            </p>
          </b-col>
          <b-col cols="6" class="text-center">
            <div>Agent</div>
            <p class="h6">
              {{booking.agent.name}}
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-card-footer>
      <b-container>
        <b-row align-v="center" class="text-center">
          <b-col cols="12" xl="6">
            <div>Persons</div>
            <p class="h6">{{booking.persons}}</p>
          </b-col>
          <b-col cols="12" xl="6">
            <div>Price</div>
            <p class="h6">{{booking.price}} €</p>
          </b-col>
        </b-row>
      </b-container>
    </b-card-footer>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ServiceVoucherBookingCard',
  props: {
    'index': {
      type: [Number, Boolean],
      default: false
    },
    'booking': {
      type: Object,
      default: null,
      required: true
    },
    'draggable': {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(
      'locations',
      [
        'locationById'
      ]
    ),
    shouldShowIndex () {
      return !!this.index
    }
  },
  methods: {
    getLocationNameById (locationId) {
      let location = this.locationById(locationId)
      return (location) ? location.name : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .serviceVoucher__card {
    transition: all 1s;

    &__handle {
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #20a8d8
      }
    }

    .card-header {
      padding: 0;
    }
    .card-body {
      padding: 0;

      .card-actions {
        border: 0;
        a {
          border: 0;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/serviceVouchers/ServiceVoucherBookingCard.vue